import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'
import { setInputRows } from '../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../components/procedure/store/procedure.types'
import { getIntubationSelector } from '../selectors'
import { IntubationConstants } from '../store/intubation.constants'
import { IIntubationState } from '../store/intubation.types'

export function* setAbandonedDateTime() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const intubationState: IIntubationState = yield select(getIntubationSelector)
  const { inputRows } = procedureState
  const { abandonedDate, abandonedTime } = intubationState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === IntubationConstants.SET_ABANDONED_DATE_TIME) {
        //@ts-ignore
        input.props.time = abandonedTime
        //@ts-ignore
        input.props.date = abandonedDate
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setAbandonedDateTimeSaga() {
  yield takeLatest(
    [
      IntubationConstants.SET_ABANDONED_TIME,
      IntubationConstants.SET_ABANDONED_DATE,
      IntubationConstants.SET_ABANDONED_DATE_TIME,
    ],
    setAbandonedDateTime
  )
}
